import { PackageIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";

type EmptyStateProps = {
  title: string;
  description: string;
  action?: ReactNode;
};

export function EmptyState({ action, description, title }: EmptyStateProps) {
  return (
    <div className="flex min-h-64 flex-col justify-center rounded-panel bg-surface-raised p-7 text-left shadow-panel sm:p-9">
      <span aria-hidden="true" className="grid size-12 place-items-center rounded-full bg-accent-soft">
        <PackageIcon className="size-6 text-accent-strong" weight="duotone" />
      </span>
      <h2 className="mt-5 text-xl font-bold tracking-tight text-text">{title}</h2>
      <p className="mt-2 max-w-xl text-sm leading-6 text-text-muted">{description}</p>
      {action ? <div className="mt-6 self-start">{action}</div> : null}
    </div>
  );
}
